import { AxiosResponse } from "axios";
import { BaseResponse } from "models/base-response";
import { LastQueue } from "models/last-queue.model";
import { NextQueue } from "models/next-queue.model";
import { Banner, Phlebotomy, RunningTextPhlebotomy } from "models/phlebotomy.model";
import { QueueItem } from "models/queue-item.model";
import { QueueNumber } from "models/queue-number.model";
import { RunningText } from "models/running-text.model";
import { StreamVideo } from "models/stream-video.model";

import BaseService from "./base.service";

export default class QueueService extends BaseService {
    constructor() {
        super(process.env.REACT_APP_SERVICE_BASE_PATH_QUEUE || '');
    }

    public getAll(outletId: string): Promise<AxiosResponse<BaseResponse<QueueItem[]>>> {
        return this.httpGet(`/v1/queue/antrean/${outletId}`);
    }

    public addQueue(outletId: string, idQueue: number): 
        Promise<AxiosResponse<BaseResponse<QueueNumber>>> {
        return this.httpPost(`/v1/queue/antrean/${outletId}/add/${idQueue}`, {});
    }

    public nextQueue(outletId: string): 
        Promise<AxiosResponse<BaseResponse<NextQueue[]>>> {
        return this.httpGet(`/v1/queue/antrean/${outletId}/next-queue`);
    }

    public getVideoUrl(outletId: string): 
        Promise<AxiosResponse<BaseResponse<StreamVideo[]>>> {
        return this.httpGet(`/v1/queue/antrean/${outletId}/video`);
    }

    public getRunningText(outletId: string): 
        Promise<AxiosResponse<BaseResponse<RunningText[]>>> {
        return this.httpGet(`/v1/queue/antrean/${outletId}/running-text`);
    }

    public getLastQueue(outletId: string): 
        Promise<AxiosResponse<BaseResponse<LastQueue>>> {
            return this.httpGet(`/v1/queue/get-antrean/${outletId}`);
    }   

    public getPhlebotomy(outletId: string, params: Record<string, any>): 
        Promise<AxiosResponse<BaseResponse<Phlebotomy[]>>> {
            return this.httpGet(`/v1/queue/display-data-phlebotomi/${outletId}`,params);
    }   

    public getBannerPhlebotomy(outletId: string): 
        Promise<AxiosResponse<BaseResponse<Banner[]>>> {
        return this.httpGet(`/v1/queue/display-banner-phlebotomi/${outletId}`);
    }

    public getRunningTextPhlebotomy(outletId: string): 
        Promise<AxiosResponse<BaseResponse<RunningTextPhlebotomy[]>>> {
        return this.httpGet(`/v1/queue/display-running-text-phlebotomi/${outletId}`);
    }
}